import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { HUText } from "@modules/ui/components/huText"
import { primaryFonts } from "@modules/ui/styles/font"
import dayjs from "dayjs"
import { useTheme } from "styled-components"

type ProgramSubscriberDetailsContentStatusProps = {
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsContentStatus({
  subscriberDetails,
  className,
  ...props
}: ProgramSubscriberDetailsContentStatusProps) {
  const defautlClassName = "flex flex-column gap-2 w-full"
  const theme = useTheme()

  const subscriptionInfos = subscriberDetails.getProgramSubscriptionStatusInfos()

  return (
    <div className={className ?? defautlClassName} {...props}>
      <div className="flex w-full gap-2 align-items-baseline">
        <HUText fontStyle="BS" color={theme.neutralColor700}>
          {word("program.subscribers.subscriptionDetails.status.title")}
        </HUText>
        <div className="flex flex-grow-1 border-top-1 border-neutralColor-300" />
      </div>
      <div className="flex flex-row gap-2 align-items-center">
        <div
          style={{
            backgroundColor: subscriptionInfos.color,
            width: primaryFonts.LS.lineHeight,
            height: primaryFonts.LS.lineHeight,
            borderRadius: primaryFonts.LS.lineHeight,
          }}
        />
        <div className="flex flex-row gap-1 align-items-center">
          <HUText fontStyle="LL" color={theme.neutralColor900}>
            {subscriptionInfos.label}
          </HUText>
          {subscriptionInfos.information ? (
            <>
              <HUText fontStyle="LM" color={theme.mainBlack}>
                ·
              </HUText>
              <HUText fontStyle="BS" color={theme.neutralColor700}>
                {subscriptionInfos.information}
              </HUText>
            </>
          ) : null}
        </div>
      </div>
      <div className="flex flex-row gap-2 align-items-center">
        <HUText fontStyle="LM" color={theme.neutralColor900}>
          {word("program.subscribers.subscriptionDetails.start.label")}
        </HUText>
        <HUText fontStyle="LM" color={theme.mainBlack}>
          ·
        </HUText>
        <HUText fontStyle="BS" color={theme.neutralColor700}>
          {dayjs(subscriberDetails.subscriptionDate).format("L")}
        </HUText>
      </div>
    </div>
  )
}
